import { render, staticRenderFns } from "./DropdownLink.vue?vue&type=template&id=2ca98a9a&"
import script from "./DropdownLink.vue?vue&type=script&lang=js&"
export * from "./DropdownLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports